import { Placeholder } from 'components';
import { FC } from 'react';

type TProps = {};

export const LiftingScreen: FC<TProps> = () => {
	return <Placeholder title="Lifting 🏋️" />;
};
